module.exports = __webpack_public_path__ + "img/title_logo.4f5a7332.png";